import { TypographyProps } from "@tvg/fuse/typography";
import React from "react";
import styles from "../Submenu.module.css";

const SectionTitle = (props: TypographyProps) => (
  <span {...props} className={styles.submenu__sectionTitle} />
);

export default SectionTitle;
